import type { PlaceType } from "@busbud/core-types/dist/lib/flex";
import type {
  SearchLeg,
  SearchPoint
} from "@busbud/core-types/dist/lib/search-info";

import type { SearchSuggestionsV2 } from "@app/types/napi-geo-entity-types";
import type { NapiRoute } from "@app/types/napi-route-types";
import type { SearchInfo } from "@app/types/search-types";

export function getLegs(search: SearchInfo, route: NapiRoute) {
  const segments: SearchLeg[] = [];

  const origin: SearchPoint = {
    type: "city",
    id: route.origin_city.id
  };

  const destination: SearchPoint = {
    type: "city",
    id: route.destination_city.id
  };

  if (search.outbound_date) {
    segments.push({
      origin,
      destination,
      date: search.outbound_date
    });
  }

  if (search.return_date) {
    segments.push({
      origin: destination,
      destination: origin,
      date: search.return_date
    });
  }

  return segments;
}

function parseSearchPointType(type: PlaceType): SearchPoint["type"] {
  /** place_type returned from flex is "location" but we support search as "place" **/
  if (type === "location") {
    return "place";
  }
  return type;
}

export function getLegsGeoEntity(
  search: Pick<SearchInfo, "outbound_date" | "return_date">,
  route: {
    origin_geo_entity: Pick<SearchSuggestionsV2, "id" | "place_type">;
    destination_geo_entity: Pick<SearchSuggestionsV2, "id" | "place_type">;
  }
) {
  const segments: SearchLeg[] = [];

  const origin: SearchPoint = {
    type: parseSearchPointType(route.origin_geo_entity.place_type),
    id: route.origin_geo_entity.id
  };

  const destination: SearchPoint = {
    type: parseSearchPointType(route.destination_geo_entity.place_type),
    id: route.destination_geo_entity.id
  };

  if (search.outbound_date) {
    segments.push({
      origin,
      destination,
      date: search.outbound_date
    });
  }

  if (search.return_date) {
    segments.push({
      origin: destination,
      destination: origin,
      date: search.return_date
    });
  }

  return segments;
}
